import { Component } from '@theme/component';
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
import { DrawerOpenEvent, DrawerCloseEvent } from '@theme/theme-drawer';

/**
 * Header actions component that manages cart notifications and the
 * cart-drawer trigger's `aria-expanded` state.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    document.addEventListener(DrawerOpenEvent.eventName, this.#onDrawerStateChange);
    document.addEventListener(DrawerCloseEvent.eventName, this.#onDrawerStateChange);
    this.#syncCartTriggerAriaExpanded();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    document.removeEventListener(DrawerOpenEvent.eventName, this.#onDrawerStateChange);
    document.removeEventListener(DrawerCloseEvent.eventName, this.#onDrawerStateChange);
  }

  #syncCartTriggerAriaExpanded = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;
    const trigger = this.querySelector('[aria-controls="cart-drawer"]');
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', cartDrawer.hasAttribute('open') ? 'true' : 'false');
  };

  /**
   * Syncs `aria-expanded` on the cart-drawer trigger when the drawer opens or closes.
   * @param {Event} event
   */
  #onDrawerStateChange = (event) => {
    const target = /** @type {HTMLElement | null} */ (event.target);
    if (target?.id !== 'cart-drawer') return;
    this.#syncCartTriggerAriaExpanded();
  };

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {CartLinesUpdateEvent} event
   */
  #onCartUpdate = (event) => {
    event.promise
      ?.then(({ cart }) => {
        const cartCount = cart?.totalQuantity;
        if (cartCount === undefined) return;

        this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[header-actions] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
// Tooltips íconos del header
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.header-actions__action.button-unstyled[aria-label]');
  
  const tooltip = document.createElement('div');
  tooltip.style.cssText = 'position:fixed;background:#202219;color:#f6eddd;padding:6px 9px;border-radius:4px;font-size:0.75rem;white-space:nowrap;z-index:99999;pointer-events:none;opacity:0;transition:opacity 0.2s ease;';
  document.body.appendChild(tooltip);

  buttons.forEach(btn => {
    btn.addEventListener('mouseenter', function() {
      const rect = btn.getBoundingClientRect();
      tooltip.textContent = btn.getAttribute('aria-label');
      tooltip.style.opacity = '1';
      tooltip.style.top = (rect.bottom + 8) + 'px';
      tooltip.style.left = (rect.left + rect.width / 2) + 'px';
      tooltip.style.transform = 'translateX(-50%)';
    });
    btn.addEventListener('mouseleave', function() {
      tooltip.style.opacity = '0';
    });
  });
});
// Tooltip ícono Cuenta
document.addEventListener('DOMContentLoaded', function() {
  const accountEl = document.querySelector('shopify-account');
  if (!accountEl) return;

  const tooltip = document.createElement('div');
  tooltip.style.cssText = 'position:fixed;background:#202219;color:#f6eddd;padding:6px 9px;border-radius:4px;font-size:0.75rem;white-space:nowrap;z-index:99999;pointer-events:none;opacity:0;transition:opacity 0.2s ease;';
  document.body.appendChild(tooltip);

  accountEl.addEventListener('mouseenter', function() {
    const rect = accountEl.getBoundingClientRect();
    tooltip.textContent = 'Cuenta';
    tooltip.style.opacity = '1';
    tooltip.style.top = (rect.bottom + 8) + 'px';
    tooltip.style.left = (rect.left + rect.width / 2) + 'px';
    tooltip.style.transform = 'translateX(-50%)';
  });
  accountEl.addEventListener('mouseleave', function() {
    tooltip.style.opacity = '0';
  });
});
